<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { TopbarService } from '../../services/topbar.service';
import type { ConfiguracaoUsuario } from '../../types/topbar.types';
import { keycloakService } from '../../services/keycloak.service';
import Button from 'primevue/button';

const topbarService = new TopbarService();
const emit = defineEmits<{
  (e: 'usuario-carregado', nome: string): void;
}>();

const configuracaoUsuario = ref<ConfiguracaoUsuario>({
  profileMode: '',
  menuLayout: '',
  enCoreSisUsuConfig: {
    nomeAbreviado: ''
  }
});


const logout = () => {
  keycloakService.keycloak.logout({
    redirectUri: window.location.origin
  });
};

onMounted(async () => {
  try {
    const data = await topbarService.getConfiguracaoUsuario();
    if (data) {
      configuracaoUsuario.value = data;
      emit('usuario-carregado', data.enCoreSisUsuConfig?.nomeAbreviado ?? '');
    }
  } catch (error) {
    console.error('Erro ao buscar as configurações de usuário:', error);
  }
});
</script>

<template>
  <header class="topbar">
    <!-- O botão de menu NÃO mora mais aqui. Ele era `pi pi-bars` com `display: none` acima de
         1024px, e aparecia mesmo assim: `.topbar-menu-toggle` e `.p-button` empatam em
         especificidade (0,1,0) e o PrimeVue injeta o CSS dos componentes no <head> em tempo de
         execução, depois do nosso arquivo — no empate ganha o último. Além de visível, não fazia
         nada no desktop, porque só alternava a classe da gaveta. Agora é o `.sidebar-toggle` do
         App.vue, que cobre os dois modos. -->

    <span v-if="configuracaoUsuario.enCoreSisUsuConfig?.nomeAbreviado" class="topbar-user-name">
      <i class="pi pi-user" aria-hidden="true" />
      {{ configuracaoUsuario.enCoreSisUsuConfig.nomeAbreviado }}
    </span>

    <Button
      icon="pi pi-sign-out"
      label="Sair"
      text
      class="p-button-sm topbar-logout"
      @click="logout"
    />
  </header>

</template>

<style scoped>
.topbar-user-name {
  display: inline-flex;
  align-items: center;
  gap: var(--c-space-2);
}

/* O "Sair" fica em texto branco sobre a barra azul; severity="danger" dava vermelho sobre azul,
   que some. A ação destrutiva aqui é sair da sessão, não apagar dado — não precisa alarmar. */
.topbar-logout:hover {
  background-color: rgba(255, 255, 255, 0.16);
}

</style>
